import React, { useState } from 'react';
import { TOKENS } from '../styles';

interface Props {
  icon: React.ReactNode;
  label: string;
  bordered?: boolean;
  active?: boolean;
  onClick?: () => void;
}

export default function ToolbarBtn({ icon, label, bordered, onClick, active }: Props) {
  const [hover, setHover] = useState<boolean>(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        background: bordered
          ? (active ? '#EEF1F4' : 'white')
          : (hover ? '#EEF1F4' : 'transparent'),
        border: bordered ? '1px solid ' + TOKENS.lineStrong : 'none',
        color: TOKENS.ink,
        fontFamily: 'inherit',
        fontSize: 13,
        cursor: 'pointer',
        padding: '8px 11px',
        borderRadius: 8,
        fontWeight: 700,
      }}
    >
      {icon}
      {label}
    </button>
  );
}